import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api-base';
import { IRuleValidationResult } from '@cbridge-packages/rule';
import { ICoverageRule } from './coverageRule.interface';

export namespace CoverageRuleAction {
  const actionCreator = actionCreatorFactory('CoverageRule');

  interface ILoadParams {
    ruleSetId: number;
  }

  interface ILoadResult {
    ruleSetId: number;
    rules: ICoverageRule[];
  }

  interface IMutateParams {
    ruleSetId: number;
    rules: ICoverageRule[];
  }

  interface IRejectedResult {
    ruleSetId: number;
    result: IRuleValidationResult[];
  }

  export const loadList = actionCreator.async<ILoadParams, ILoadResult, IApiErrorParams>('LOAD_LIST');
  export const update = actionCreator.async<IMutateParams, IRuleValidationResult[], IApiErrorParams>('UPDATE');
  export const validate = actionCreator.async<IMutateParams, IRuleValidationResult[], IApiErrorParams>('VALIDATE');
  // The backend rejected the whole request (400) naming some rules — partial, unlike `done`.
  export const validationRejected = actionCreator<IRejectedResult>('VALIDATION_REJECTED');

  export const destroy = actionCreator('DESTROY');
}
